"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContactNameHash = exports.isContact = exports.getContactPhoneNumber = void 0;
var web3_utils_1 = require("web3-utils");
// Exports moved to @celo/base, forwarding them
// here for backwards compatibility
var contacts_1 = require("@celo/base/lib/contacts");
Object.defineProperty(exports, "getContactPhoneNumber", { enumerable: true, get: function () { return contacts_1.getContactPhoneNumber; } });
Object.defineProperty(exports, "isContact", { enumerable: true, get: function () { return contacts_1.isContact; } });
/**
 * @deprecated May be removed in future
 */
var getContactNameHash = function (contact) {
    if (!contact) {
        throw new Error('Invalid contact');
    }
    return (0, web3_utils_1.keccak256)(contact.displayName || '');
};
exports.getContactNameHash = getContactNameHash;
//# sourceMappingURL=contacts.js.map